import {
  Home,
  Inbox,
  Briefcase,
  Files,
  FileText,
  Sparkles,
  Database,
  AlertTriangle,
  BarChart3,
  Library,
  Workflow,
  Users,
  User,
  Server,
  Shield,
  ShieldCheck,
  Settings,
  Bell,
  Search,
  Plus,
  Menu,
  X,
  Check,
  Clock,
  MessageSquare,
  PenLine,
  Download,
  Upload,
  GitBranch,
  GitCompare,
  History,
  Eye,
  Pencil,
  Link as LinkI,
  Paperclip,
  List,
  Cloud,
  Filter,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown as ChevronDownIcon,
  ArrowRight,
  ArrowLeft,
  PieChart,
  LayoutTemplate,
  Box,
  Building2,
  Brain,
  Layers,
  MoreHorizontal,
  MoreVertical,
  ExternalLink,
  Trash2,
  Save,
  Copy,
  Mail,
  AtSign,
  Tag,
  Hash,
  Star,
  Bookmark,
  Calendar,
  MapPin,
  Pin,
  PinOff,
  Globe,
  Lock,
  Unlock,
  Key,
  LogIn,
  LogOut,
  RefreshCw,
  Loader2,
  CheckCircle2,
  XCircle,
  AlertCircle,
  Info,
  HelpCircle,
  Play,
  Pause,
  Square as Stop,
  Zap,
  Activity,
  Gauge,
  TrendingUp,
  TrendingDown,
  BarChart2,
  LineChart,
  ScrollText,
  BookOpen,
  FolderOpenDot,
  FolderOpen,
  Folder,
  Send,
  Sparkle,
  Wand2,
  MessageCircle,
  ThumbsUp,
  ThumbsDown,
  Cpu,
  Code2,
  type LucideIcon,
  Scale,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
  Maximize2,
  Minimize2,
  Expand,
  Shrink,
  ZoomIn,
  ZoomOut,
  Quote,
  Palette,
  Printer,
  Archive,
  WifiOff,
  RotateCcw,
  Keyboard,
  Smartphone,
  TreePine,
  Bold,
  Italic,
  Underline as UnderlineIcon,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  IndentIncrease,
  IndentDecrease,
  Table as TableIcon,
  Undo2,
  Redo2,
  Type,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Pilcrow,
  ListOrdered,
  Baseline,
} from "lucide-react";

/* ---------- Icon mapping ----------
 * Maps the prototype's string-based icon names to lucide-react components.
 * The wrapper applies the editorial stroke-width of 1.6 by default.
 */
export const ICON_MAP = {
  // navigation
  home: Home,
  inbox: Inbox,
  briefcase: Briefcase,
  docs: Files,
  doc: FileText,
  spark: Sparkles,
  cpu: Cpu,
  code: Code2,
  database: Database,
  alert: AlertTriangle,
  chart: BarChart3,
  library: Library,
  workflow: Workflow,
  users: Users,
  user: User,
  server: Server,
  shield: Shield,
  shieldAlt: ShieldCheck,
  settings: Settings,
  bell: Bell,
  search: Search,
  plus: Plus,
  menu: Menu,
  close: X,
  check: Check,
  clock: Clock,
  comment: MessageSquare,
  signature: PenLine,
  download: Download,
  upload: Upload,
  branch: GitBranch,
  diff: GitCompare,
  history: History,
  eye: Eye,
  edit: Pencil,
  link: LinkI,
  paperclip: Paperclip,
  list: List,
  cloud: Cloud,
  filter: Filter,
  chevronD: ChevronDown,
  chevronUp: ChevronUp,
  chevronDown: ChevronDownIcon,
  chevronR: ChevronRight,
  chevronL: ChevronLeft,
  arrowR: ArrowRight,
  arrowL: ArrowLeft,
  pieChart: PieChart,
  template: LayoutTemplate,
  cube: Box,
  building: Building2,
  brain: Brain,
  layers: Layers,
  more: MoreVertical,
  moreH: MoreHorizontal,
  external: ExternalLink,
  trash: Trash2,
  save: Save,
  copy: Copy,
  mail: Mail,
  at: AtSign,
  tag: Tag,
  hash: Hash,
  star: Star,
  bookmark: Bookmark,
  calendar: Calendar,
  pin: Pin,
  pinOff: PinOff,
  mapPin: MapPin,
  globe: Globe,
  lock: Lock,
  unlock: Unlock,
  key: Key,
  login: LogIn,
  logout: LogOut,
  refresh: RefreshCw,
  refreshCw: RefreshCw,
  spinner: Loader2,
  checkCirc: CheckCircle2,
  xCirc: XCircle,
  alertCirc: AlertCircle,
  info: Info,
  help: HelpCircle,
  play: Play,
  pause: Pause,
  stop: Stop,
  zap: Zap,
  activity: Activity,
  gauge: Gauge,
  trendUp: TrendingUp,
  trendDown: TrendingDown,
  bars: BarChart2,
  line: LineChart,
  scroll: ScrollText,
  book: BookOpen,
  folderOpen: FolderOpenDot,
  folderOpen2: FolderOpen,
  folder: Folder,
  send: Send,
  sparkle: Sparkle,
  wand: Wand2,
  msg: MessageCircle,
  thumbUp: ThumbsUp,
  thumbDown: ThumbsDown,
  scale: Scale,
  panelLeftClose: PanelLeftClose,
  panelLeftOpen: PanelLeftOpen,
  panelRightClose: PanelRightClose,
  panelRightOpen: PanelRightOpen,
  maximize: Maximize2,
  minimize: Minimize2,
  expand: Expand,
  shrink: Shrink,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  quote: Quote,
  palette: Palette,
  printer: Printer,
  archive: Archive,
  wifiOff: WifiOff,
  rotateCcw: RotateCcw,
  keyboard: Keyboard,
  smartphone: Smartphone,
  treeStructure: TreePine,
  bold: Bold,
  italic: Italic,
  underline: UnderlineIcon,
  strikethrough: Strikethrough,
  alignLeft: AlignLeft,
  alignCenter: AlignCenter,
  alignRight: AlignRight,
  alignJustify: AlignJustify,
  indentIncrease: IndentIncrease,
  indentDecrease: IndentDecrease,
  table: TableIcon,
  undo: Undo2,
  redo: Redo2,
  type: Type,
  heading1: Heading1,
  heading2: Heading2,
  heading3: Heading3,
  heading4: Heading4,
  pilcrow: Pilcrow,
  listOrdered: ListOrdered,
  textColor: Baseline,
} as const;

export type IconName = keyof typeof ICON_MAP;

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  strokeWidth?: number;
  "aria-hidden"?: boolean;
}

export function Icon({
  name,
  size = 18,
  className,
  strokeWidth = 1.6,
  ...rest
}: IconProps) {
  const C: LucideIcon = ICON_MAP[name];
  if (!C) return null;
  return (
    <C
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden
      {...rest}
    />
  );
}

export type { LucideIcon };
